import Vue from "vue";
import VueApollo from "vue-apollo";
import { ApolloClient } from "apollo-client";
import { HttpLink } from "apollo-link-http";

import { ApolloLink } from "apollo-link";
import { InMemoryCache } from "apollo-cache-inmemory";
import { GRAPHQL_SERVER } from "@/utils/constant";
import { lsUtils } from "@/utils/localStorageUtils";

const httpLink = new HttpLink({
  uri: GRAPHQL_SERVER,
});
const authLink = new ApolloLink((operation, forward) => {
  const obj = {};
  if (lsUtils.getItem("userToken").token) {
    const tok = lsUtils.getItem("userToken").token || null;
    if (tok) {
      obj.authorization = "Bearer " + tok;
    }
  }
  operation.setContext(({ headers }) => ({
    headers: {
      ...obj,
      ...headers,
    },
  }));
  return forward(operation);
});

const link = authLink.concat(httpLink);
const apolloClient = new ApolloClient({
  link,
  cache: new InMemoryCache({
    dataIdFromObject: (object) => `${object.__typename}-${object.id}`,
  }),
  queryDeduplication: false,
  defaultOptions: {
    watchQuery: {
      errorPolicy: "all",
    },
    query: {
      errorPolicy: "all",
    },
    mutate: {
      errorPolicy: "all",
    },
  },
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
});

Vue.use(VueApollo);

export default apolloProvider;
